export default function resetSearchParams(defaultFilters, storageType) {
	const searchParams = { page: null };
	const filters = defaultFilters[storageType];
	Object.keys(filters).forEach((filterName) => {
		const filter = filters[filterName];
		if (filter.options) {
			filter.options.forEach((option) => {
				if (option.name === 'sort') {
					searchParams[option.name] =
						'yielddistancelowltveconmir100forced';
				} else {
					searchParams[option.name] = null;
				}
			});
		}
	});
	return searchParams;
}
